import EtatBadge from "./EtatBadge";


// =========================
// FORMAT DATE
// =========================

const formatDateFR = (dateISO) => {
  if (!dateISO) return "";

  const [y, m, d] = dateISO
    .split("T")[0]
    .split("-");

  return `${d}/${m}/${y}`;
};


// =========================
// FORMAT HEURE
// =========================

const formatHeure = (heure) => {
  if (!heure) return "";

  return heure.substring(0, 5);
};


// =========================
// CALCUL HEURES
// =========================

const calculerHeures = (
  heureDebut,
  heureFin
) => {

  if (!heureDebut || !heureFin) return 0;

  const [h1, m1] =
    heureDebut.split(":").map(Number);

  const [h2, m2] =
    heureFin.split(":").map(Number);

  const debut =
    h1 * 60 + m1;

  const fin =
    h2 * 60 + m2;

  if (fin <= debut) return 0;

  return (
    (fin - debut) / 60
  ).toFixed(2);
};


// =========================
// TABLEAU
// =========================

const RendezVousTable = ({
  data,
  onEdit,
  onDelete,
  onEditHeureFin,
  entretiens,
  clients,
  onChangeEtat,
}) => {

  return (

    <table className="responsive-table">

      <thead>

        <tr>

          <th>Technicien</th>

          <th>Date</th>

          <th>Heure début</th>

          <th>Type entretien</th>

          <th>Client</th>

          <th>Note admin</th>

          <th>État</th>

          <th>Remarque tech</th>

          <th>Heure fin</th>

          <th>NB Heure</th>

          <th>Actions</th>

        </tr>

      </thead>


      <tbody>

        {data.map((rv) => (

          <tr key={rv.id}>


            {/* =========================
                TECHNICIEN
            ========================== */}

            <td data-label="Technicien">

              {rv.technicien || "-"}

            </td>


            {/* =========================
                DATE
            ========================== */}

            <td data-label="Date">

              {formatDateFR(
                rv.date_rdv
              )}

            </td>


            {/* =========================
                HEURE DÉBUT
            ========================== */}

            <td data-label="Heure début">

              {formatHeure(
                rv.heure_debut
              )}

            </td>


            {/* =========================
                TYPE ENTRETIEN
            ========================== */}

            <td data-label="Type entretien">

              {
                entretiens.find(
                  (t) =>
                    t.id ===
                    rv.type_entretien_id
                )?.nom || "-"
              }

            </td>


            {/* =========================
                CLIENT
            ========================== */}

            <td data-label="Client">

              {
                clients?.find(
                  (c) =>
                    c.id ===
                    rv.client_id
                )?.nom

                ||

                rv.client

                ||

                "-"
              }

            </td>


            {/* =========================
                NOTE ADMINISTRATEUR
            ========================== */}

            <td data-label="Note admin">

              {rv.note ? (

                <span className="note-tooltip">

                  <span className="note-icon">
                    📝
                  </span>

                  <span className="tooltip-content">

                    <strong>
                      Note administrateur
                    </strong>

                    <span className="tooltip-text">
                      {rv.note}
                    </span>

                  </span>

                </span>

              ) : (

                <span className="empty-value">
                  —
                </span>

              )}

            </td>


            {/* =========================
                ÉTAT
            ========================== */}

            <td data-label="État">

              {rv.etat_travaux ===
              "TERMINE" ? (

                <EtatBadge
                  etat={
                    rv.etat_travaux
                  }
                />

              ) : (

                <select
                  value={
                    rv.etat_travaux
                  }
                  onChange={(e) =>
                    onChangeEtat(
                      rv.id,
                      e.target.value
                    )
                  }
                >

                  <option value="EN_ATTENTE">
                    En attente
                  </option>

                  <option value="EN_COURS">
                    En cours
                  </option>

                  <option value="TERMINE">
                    Terminé
                  </option>

                </select>

              )}

            </td>


            {/* =========================
                REMARQUE TECHNICIEN
            ========================== */}

            <td data-label="Remarque tech">

              {rv.remarque ? (

                <span className="note-tooltip">

                  <span className="remarque-icon">
                    🔧
                  </span>

                  <span className="tooltip-content">

                    <strong>
                      Remarque technicien
                    </strong>

                    <span className="tooltip-text">
                      {rv.remarque}
                    </span>

                  </span>

                </span>

              ) : (

                <span className="empty-value">
                  —
                </span>

              )}

            </td>


            {/* =========================
                HEURE FIN
            ========================== */}

            <td data-label="Heure fin">

              {rv.etat_travaux ===
              "TERMINE" ? (

                <input
                  type="time"
                  value={
                    formatHeure(
                      rv.heure_fin
                    ) || ""
                  }
                  onChange={(e) =>
                    onEditHeureFin(
                      rv.id,
                      e.target.value
                    )
                  }
                />

              ) : (

                formatHeure(
                  rv.heure_fin
                )

              )}

            </td>


            {/* =========================
                NB HEURE
            ========================== */}

            <td data-label="NB Heure">

              {rv.heure_fin ? (

                calculerHeures(
                  rv.heure_debut,
                  rv.heure_fin
                ) + " h"

              ) : (

                "-"

              )}

            </td>


            {/* =========================
                ACTIONS
            ========================== */}

            <td data-label="Actions">

              <div className="rdv-actions">

                <button
                  type="button"
                  onClick={() =>
                    onEdit(rv)
                  }
                  title="Modifier"
                >
                  ✏️
                </button>


                <button
                  type="button"
                  onClick={() =>
                    onDelete(rv.id)
                  }
                  title="Supprimer"
                >
                  🗑️
                </button>

              </div>

            </td>


          </tr>

        ))}

      </tbody>

    </table>

  );
};


export default RendezVousTable;
